import { Component, OnInit, ViewChild } from "@angular/core";
import swal from 'sweetalert2';
import {
  MdbTablePaginationComponent,
  MdbTableDirective,
  ModalDirective,
} from "angular-bootstrap-md";
import { Router } from "@angular/router";
import { FormBuilder } from "@angular/forms";
import { AlertService } from "ngx-alerts";

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Inventario } from "../../inventario";
import { Producto } from "../../producto";
import { ComprasService } from "../../compras.service";
import { ProductoService } from "../../producto.service";
import { UnidadService } from "../../unidad.service";
import { Unidades } from "../../unidades";
import { environment } from "../../../environments/environment";
import { Clientes } from "../../cliente";
import { Compras } from "../../compras";
import { Compradetalle } from "../../compradetalle";
import { ClienteService } from "../../cliente.service";
import { ProveedorService } from "../../proveedor.service";
import { NgSelectConfig } from "@ng-select/ng-select";
import { ProductoPrecio } from "../../productoPrecio";
import { SafeUrl } from "@angular/platform-browser";
import { NgxXml2jsonService } from 'ngx-xml2json';
import { factura } from "../../factura-electronica";
import { InfoTributaria } from "../../info-tributaria";
import { Detalle } from "../../detalle";
import { DatePipe } from "@angular/common";
import { element } from "protractor";
import { FacturaService } from "../../factura.service";
import { Peso } from "../../peso";
import { Emisor } from "../../emisor";
import { EmisorService } from "../../emisor.service";

@Component({
  selector: "app-compras",
  templateUrl: "./compras.component.html",
  styleUrls: ["./compras.component.scss"],
})
export class ComprasComponent implements OnInit {
  btnDisabled = false;
  cliente: Clientes = new Clientes();
  inventario: Inventario;
  events: Event[] = [];
  emisor: Emisor;
  listaClientesActulizar: Clientes[] = [];
  detalles: Detalle[] = [];
  porcentajeIva: number;
  ruc: string;
  compras: Compras;
  urlImagen: SafeUrl | null = null;
  listCliene: Clientes[];
  codigoBarras: string;
  productoSelecionado: Producto;
  facturaJson: any
  listaCompras: Compras[] = [];
  compraDetalle: Compradetalle[] = [];
  listaBuscarProducto: Producto[] = [];
  compraDetall: Compradetalle;
  @ViewChild(MdbTablePaginationComponent)
  mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective) mdbTable: MdbTableDirective;
  @ViewChild("processingModal") public mdbModal: ModalDirective;
  subTotal: number;
  iva: number;
  url: string;
  urlSafe: SafeResourceUrl;
  total: number;
  listaPrecios: ProductoPrecio[] = [];
  blod: Blob;


  constructor(
    private datePipe: DatePipe,
    private apiEmisor: EmisorService,
    private apiClie: ProveedorService,
    private ruter: Router,
    private formBuilder: FormBuilder,
    private apiCompras: ComprasService,
    private apiProducto: ProductoService,
    private alertService: AlertService,
    private apiUnidad: UnidadService,
    private apiFac: FacturaService,
    public sanitizer: DomSanitizer,
    private ngxXml2jsonService: NgxXml2jsonService,
    private config: NgSelectConfig) {
    this.config.notFoundText = 'No se encuenta';
    this.config.appendTo = 'body';
    // set the bindValue to global config when you use the same 
    // bindValue in most of the place. 
    // You can also override bindValue for the specified template 
    // by defining `bindValue` as property
    // Eg : <ng-select bindValue="some-new-value"></ng-select>
    this.config.bindValue = 'value';
    this.btnDisabled = false;

  }


  listarProductoParaBuscar() {
    this.apiProducto.getProducto(localStorage.getItem('id'))
      .subscribe((
        data: Producto[]) => {
        this.listaBuscarProducto = data;

      }
        , err => {
          console.log(err);

        });



  }



  printer(entidad: Compradetalle) {

    let pvp1, pvp2;


    this.apiProducto.getProductoPrecio(entidad.idProducto.toString(), localStorage.getItem('id'))
      .subscribe((
        data: ProductoPrecio[]) => {
        this.listaPrecios = data;
        if (this.listaPrecios.length > 0) {
          pvp1 = 'PVP($) ' + this.listaPrecios[0].precioVenta;
        }
        if (this.listaPrecios.length > 1) {
          pvp2 = 'PVP($) ' + this.listaPrecios[1].precioVenta;
        } else {
          pvp2 = "";
        }

        if (localStorage.getItem('id') == '508') {
          this.apiProducto.getEtiquetaVentaPink(entidad.nombre, entidad.codigoPrincipal, pvp2, pvp1).subscribe((file1) => {

            this.blod = new Blob([file1], { type: 'application/pdf' });
            const url1 = window.URL.createObjectURL(this.blod);
            this.urlImagen = this.sanitizer.bypassSecurityTrustUrl(url1);
            var downloadURL = URL.createObjectURL(this.blod);
            window.open(downloadURL);

          }
          );
        } else {
          this.apiProducto.getEtiquetaVenta(entidad.nombre, entidad.codigoPrincipal, pvp2, pvp1).subscribe((file1) => {

            this.blod = new Blob([file1], { type: 'application/pdf' });
            const url1 = window.URL.createObjectURL(this.blod);
            this.urlImagen = this.sanitizer.bypassSecurityTrustUrl(url1);
            var downloadURL = URL.createObjectURL(this.blod);
            window.open(downloadURL);

          }
          );
        }



      }

        , err => {
          console.log(err);
          //this.isLoadingResults = false;
        });





  }



  limpiarCadena(cadena) {
    const cleanString = cadena.replace(/\s{2,}/g, ' ').trim();
    console.log(cadena);
    return cleanString;
  }

  onFileChange(evt: any) {
    swal.fire({
      title: "Información",
      text: "Cargar Archivo XML",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        const file = evt.target.files[0];
        if (!file) {
          return;
        }
        const reader = new FileReader();
        reader.onload = (evt) => {
          const xmlData: string = (evt as any).target.result;
          const parser = new DOMParser();
          const xml = parser.parseFromString(xmlData, 'text/xml');
          const value = xml.getElementsByTagName('comprobante')[0].innerHTML.replace("<![CDATA[", "");
          const xml1 = parser.parseFromString(value, 'text/xml');
  
          let facturaJson = this.ngxXml2jsonService.xmlToJson(xml1) as factura;
  
          this.detalles = facturaJson.factura.detalles;
          this.ruc = facturaJson.factura.infoTributaria.ruc;
          this.cliente.codcliente = 0;
          this.cliente.nombrerazonsocial = facturaJson.factura.infoTributaria.razonSocial;
          this.cliente.numeroidentificacion = facturaJson.factura.infoTributaria.ruc;
          this.cliente.direccion = facturaJson.factura.infoTributaria.dirMatriz;
          this.compras.tipoCompra = 'F';
          this.compras.numeroAutorizacion = facturaJson.factura.infoTributaria.claveAcceso;
          this.compras.factura = facturaJson.factura.infoTributaria.secuencial;
          this.compras.serie = facturaJson.factura.infoTributaria.estab + "" + facturaJson.factura.infoTributaria.ptoEmi;
          this.compras.cliente = this.cliente;
          const str = facturaJson.factura.infoFactura.fechaEmision;
          this.compras.xml = 'S';
          const [day, month, year] = str.split('/');
  
          console.log(month);
          console.log(day);
          console.log(year);
  
          const fecha = new Date(year, month - 1, day); // Asegúrate de restar 1 al mes, ya que en JS es 0-11
          this.compras.fecha = fecha.toString();
          this.detalles.forEach(elementd => {
            elementd.detalle.forEach(elementd1 => {
              this.compraDetall = new Compradetalle();
              this.compraDetall.idProducto = 1;
              this.compraDetall.nombre = this.limpiarCadena(elementd1.descripcion);
              this.compraDetall.cantidadPedida = elementd1.cantidad;
              this.compraDetall.precioCosto = elementd1.precioUnitario;
              this.compraDetall.codigoPrincipal = this.limpiarCadena(elementd1.codigoPrincipal);
              this.compraDetall.codigoAuxiliar = this.limpiarCadena(elementd1.codigoPrincipal);
              this.compraDetall.cod = elementd1.codigoAuxiliar;
              this.compraDetall.factor = 1;
              this.compraDetall.descuento = 0;
              if (elementd1.impuestos.impuesto.tarifa > 0) {
                this.compraDetall.iva = "S";
                this.compraDetall.valorIva = parseFloat(elementd1.impuestos.impuesto.valor);
              } else {
                this.compraDetall.iva = "N";
                this.compraDetall.valorIva = 0;
              }
              this.compraDetall.ordenar = this.compraDetalle.length + 1;
              this.valueChangeCantidad(this.compraDetall);
              this.compraDetalle.push(this.compraDetall);
              this.mdbTable.setDataSource(this.compraDetalle);
              this.mdbTable.dataSourceChange();
              this.calcular();
            });
          });
        };
        reader.readAsText(file);
      }
    });
  }


  onSearch($event) {
    this.productoSelecionado.codigoPrincipal = $event.term;
    //  this.buscarProducto();
  }


  buscarProducto() {
    let validar = 0;
    this.compraDetalle.forEach(element => {
      if (this.productoSelecionado.codigoPrincipal == element.cod) {
        let validar = 1;
      }
    });
    if (validar == 0) {
      let codigoPrincipal = this.productoSelecionado.codigoPrincipal
      if (codigoPrincipal != null) {
        this.apiProducto
          .getProductoPorCodigo(
            this.productoSelecionado.codigoPrincipal,
            localStorage.getItem("id")
          )
          .subscribe(
            (data: Producto[]) => {
              console.log(data);
              if (data.length > 0) {
              } else {
                //this.alertService.danger("No existe el producto...");
                //this.productoSelecionado.codigoPrincipal = null;
              }
              data.forEach((item) => {
                this.productoSelecionado = item;
                if (this.productoSelecionado == null) {
                  this.alertService.danger("No existe el producto...");
                  this.productoSelecionado.codigoPrincipal = null;
                } else {
                  if (this.compras.tipoDoc == 'E') {
                    this.apiCompras
                      .inventarioProducto(this.productoSelecionado.codigo)
                      .subscribe((dataInv: Inventario) => {
                        console.log(dataInv);
                        if (dataInv.cantidad == null) {
                          this.alertService.danger("No hay stock...");
                          this.productoSelecionado.codigoPrincipal = null;
                        } else {

                        }
                        if (dataInv.cantidad > 0) {

                          this.productoSelecionado.codigoPrincipal = null;
                          this.productoSelecionado.cantidad = 1;
                          this.compraDetall = new Compradetalle();
                          this.compraDetall.idProducto = this.productoSelecionado.codigo;
                          this.compraDetall.nombre = this.productoSelecionado.nombre;
                          this.compraDetall.cantidad = this.productoSelecionado.cantidad;
                          this.compraDetall.iva = this.productoSelecionado.iva;
                          //this.compraDetall.precioCosto=this.productoSelecionado.costo;
                          this.compraDetall.codigoPrincipal = codigoPrincipal;
                          this.compraDetall.ordenar = this.compraDetalle.length + 1;
                          this.compraDetalle.push(this.compraDetall);
                          this.mdbTable.setDataSource(this.compraDetalle);
                          this.mdbTable.dataSourceChange();
                          this.calcular();
                        }
                      });
                  } else {
                    try {
                      this.apiUnidad.getUnidad(this.productoSelecionado.idUnidad.toString())
                        .subscribe(
                          (data: Unidades[]) => {

                            data.forEach((item) => {
                              console.log(data);
                              this.productoSelecionado.codigoPrincipal = null;
                              this.productoSelecionado.cantidad = 1;
                              this.compraDetall = new Compradetalle();
                              this.compraDetall.idProducto = this.productoSelecionado.codigo;
                              this.compraDetall.nombre = this.productoSelecionado.nombre;
                              this.compraDetall.cantidad = this.productoSelecionado.cantidad;
                              this.compraDetall.factor = item.factor;
                              this.compraDetall.cod = codigoPrincipal
                              this.compraDetall.descuento = 0;
                              //this.compraDetall.iva=this.productoSelecionado.iva;
                              this.compraDetall.precioCosto = this.productoSelecionado.costo;
                              //this.compraDetall.codigoPrincipal=codigoPrincipal;
                              this.compraDetall.unidadCompra = item.descripcion;
                              this.compraDetall.ordenar = this.compraDetalle.length + 1;
                              this.compraDetalle.push(this.compraDetall);
                              this.mdbTable.setDataSource(this.compraDetalle);
                              this.mdbTable.dataSourceChange();
                              this.calcular();
                            })
                          }
                          , err => {
                            console.log(err);

                          });
                    } catch (error) {

                    }


                  }
                }
              });
            },
            (err) => {
              this.alertService.danger("Problemas con la conexión");
            }
          );
      }
    }
  }

  valueChangeCantidad(compra: Compradetalle) {
    this.compraDetall = compra;
    this.compraDetall.total =
      this.compraDetall.cantidadPedida * this.compraDetall.precioCosto;
    this.compraDetall.total = this.compraDetall.total - this.compraDetall.descuento;
    this.compraDetall.cantidad = this.compraDetall.cantidadPedida * this.compraDetall.factor;
    this.calcular();
  }


  valueChangeCosto(newValue, compra: Compradetalle) {
    this.compraDetall = compra;
    this.compraDetall.descuento = Number.parseFloat(newValue);
    this.compraDetall.total =
      this.compraDetall.cantidadPedida * this.compraDetall.precioCosto;
    this.compraDetall.total = this.compraDetall.total - Number.parseFloat(newValue);
    this.compraDetall.cantidad = this.compraDetall.cantidadPedida * this.compraDetall.factor;
    this.calcular();
  }

  valueChangeIva(newValue, compra: Compradetalle) {
    this.compraDetall = compra;
    if (newValue == 'S') {
      this.compraDetall.valorIva = this.compraDetall.total * this.porcentajeIva;

    } else {
      this.compraDetall.valorIva = 0;;
    }
    this.calcular();
  }

  eliminar(numero: number) {
    //this.removeAllElements( this.listaProductos,numero);

    this.compraDetalle.forEach((value, index) => {
      if (value.ordenar == numero) this.compraDetalle.splice(index, 1);
    });

    //this.compraDetalle.splice(numero, 1);
    this.mdbTable.setDataSource(this.compraDetalle);
    this.mdbTable.dataSourceChange();
    this.calcular();
  }


  onChange(newValue) {
    console.log(newValue);
    this.compras.tipoCompra = newValue;
    this.calcular();

  }

  redondearValor(numero: number) {

    return Math.round((numero + Number.EPSILON) * 100) / 100;
  }
  calcular() {


    this.subTotal = 0.0;
    this.total = 0.0;
    this.iva = 0.0;

    this.compraDetalle.forEach((item) => {
      this.subTotal = this.redondearValor(this.subTotal + item.total);
    });

    this.compraDetalle.forEach((item) => {
      this.iva = this.redondearValor(this.iva + item.valorIva);
    });
    this.total = this.redondearValor(this.iva + this.subTotal);
  }

  onChange1($event: Event) {
    this.buscarCedula();
  }


  peso(entidad: Compradetalle) {
    this.apiFac.getUltimoPeso(localStorage.getItem("id"))
      .subscribe((
        varPeso: Peso[]) => {
        varPeso.forEach(elemUnidad => {
          entidad.cantidadPedida = elemUnidad.peso
          this.valueChangeCantidad(entidad);
        })
      });

  }

  onChangeProducto($event) {
    this.productoSelecionado.codigoPrincipal = $event;
    this.buscarProducto();

  }
  listarProveedor() {
    this.apiClie
      .getClientes(
        localStorage.getItem("id")
      )
      .subscribe(
        (data: Clientes[]) => {
          this.listCliene = data;
          console.log(this.listCliene);
        });
  }




  buscarCedula() {
    this.apiClie
      .getCliente(
        this.ruc
      )
      .subscribe(
        (data: Clientes[]) => {
          data.forEach((item) => {
            this.cliente = item;

            if (this.cliente == null) {
              this.alertService.danger("No existe la cédula o Ruc");
              this.cliente.numeroidentificacion = null;
            }
          });
        },
        (err) => {
          this.alertService.danger("Problemas con la conexión");
        }
      );
  }

  limpiar() {
    this.cliente = new Clientes();
    this.compras = new Compras();
    this.productoSelecionado = new Producto();
    this.compraDetalle = [];
    this.subTotal = 0;
    this.iva = 0;
    this.total = 0;
    this.btnDisabled = false;
    this.mdbTable.setDataSource(this.compraDetalle);
    this.mdbTable.dataSourceChange();
  }

  ngOnInit() {
    this.consultarEmisor();
    this.listarProveedor();
    this.listarProductoParaBuscar();
    //this.porcentajeIva = 0.0;
    this.limpiar();
   

  }

  consultarEmisor(){
    

    this.apiEmisor.getEmisor(localStorage.getItem('id')).subscribe
    ((data: Emisor[]) => {
      console.log(data);
      data.forEach(item => {
        this.emisor = item;
        this.porcentajeIva=this.emisor.iva;
        console.log(this.emisor);
      });
    });
      

  }

  nuevo() {
    this.ngOnInit();
  }




  actulizarDatosCliente() {

    if (confirm("Está seguro de actualizar")) {

      this.listaClientesActulizar[0] = this.cliente;
      this.apiClie.setActulizarCliente(this.listaClientesActulizar).subscribe(

        data => {
          this.alertService.success("Se agrego un nuevo cliente");
          this.mdbModal.hide();
          this.listarProveedor();

        },

        error => {

          this.alertService.danger(error)

        }

      );
    }
  }



  guardar() {
    this.btnDisabled = true;
    if (this.cliente.codcliente == null) {
      this.alertService.danger('Debe seleccionar  el proveedor....');
      this.btnDisabled = false;
    } else if (this.compras.tipoCompra == 'F' && (this.compras.factura == null || this.compras.serie == null)) {
      this.alertService.danger('Debe ingresar la factura y la serie del documento...');
      this.btnDisabled = false;
    } else if (this.compraDetalle.length == 0) {
      this.alertService.danger('No hay productos ingresados......');
      this.btnDisabled = false;
    } else if (typeof this.compras.tipoCompra === 'undefined') {
      this.alertService.danger('Debe seleccionar el tipo de comprobante..');
      this.btnDisabled = false;
    } else {
      this.compras.id = 0;
      this.compras.idCliente = this.cliente.codcliente;
      this.compras.valorTotal = this.total;
      this.compras.valorIva = this.iva;
      this.compras.valorSubTotal = this.subTotal;
      this.compras.fechaP = this.compras.fecha
      // this.compras.tipoCompra="I";
      this.compras.tipoDoc = "I";
      this.compras.enviado = "S"
      this.compras.det = this.compraDetalle;

      this.compras.idEmisor = Number.parseInt(localStorage.getItem("id"));
      this.listaCompras[0] = this.compras;

      this.apiCompras.setActulizarCompras(this.listaCompras).subscribe(
        (data) => {


          console.log(data);
          this.url = environment.apiReportes + "movimientos.rptdesign&id=" + data.id + "&__emitterid=org.eclipse.birt.report.engine.emitter.pdf";
          window.open(this.url, '', 'left=0,top=0,width=900,height=900,toolbar=0,scrollbars=0,status=0');

          this.limpiar();
          this.ruter.navigate(['detallecompras']);
          this.btnDisabled = false;

        },
        (error) => {
          this.btnDisabled = false;
          this.alertService.danger(error);
        }
      );
    }
  }
}
